<template>
  <div v-if="$config.isShowAppBar">
    <v-app-bar
      flat
      dense
      color="white"
      class="v-app-bar--app"
    >
      <!-- <v-app-bar-nav-icon
        color="#333"
        @click.stop="drawer = !drawer"
      /> -->
      <v-btn
        icon
        to="/"
        class="v-btn--no-active"
      >
        <v-icon>
          {{ mdiHomeOutline }}
        </v-icon>
      </v-btn>
      <!-- <v-toolbar-title class="text-h5 pl-0">
        <router-link
          to="/"
          style="text-decoration: none;"
        >
          <img
            :src="require('../assets/govmo-logo.png')"
          >
        </router-link>
      </v-toolbar-title> -->
      <v-spacer />
      <v-btn
        icon
        @click="changeLang"
      >
        <v-icon>{{ mdiTranslate }}</v-icon>
      </v-btn>
      <!-- <img
        class="d-none d-sm-inline profile-img mr-2"
        :src="staffPhoto"
      >
      <span class="d-none d-md-inline grey--text">{{ username }}</span> -->
    </v-app-bar>
  </div>
</template>

<style scoped>
  .text-h5 {
    padding-top: 10px;
  }

  .sub-title {
    font-size: 17px;
    color: rgba(255, 255, 255, 0.6);
  }

  .profile-img {
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }

  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active.v-btn--no-active:before {
    opacity: 0;
  }
</style>

<script>

import { mdiHomeOutline, mdiTranslate } from '@mdi/js'

// import SAppIcon from '@/components/SAppIcon'
// import { mapState } from 'vuex'
import store from '../store'
import storageUtil from '../utils/storageUtil'
import { workflowModule, staffModule } from '../store/moduleName'
import { workflow } from '../store/modules/workflow/workflow'
// import g2eApi from '../api/hr/g2e'
// import constant from '@/constant/constant'
// import axios from 'axios'
// import { isFieldBlank } from '../utils/stringUtil'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

// const G2E_JWT_TOKEN = 'g2e-jwt-token'
// const LOGOUT_URL = 'https://entity-account.safp.gov.mo/zh-hant/logout/'

export default {
  components: {
    // SAppIcon
  },
  data: () => ({
    mdiHomeOutline: mdiHomeOutline,
    mdiTranslate: mdiTranslate,
    // drawer: false,
    // menuList: null,
    group: false
    // windowSize: { x: 0, y: 0 },
    // staffPhoto: null
  }),
  computed: {
    // mainDrawerStyleObj: function () {
    //   let tHeight = '64px'
    //   if (this.windowSize.x < 1024) {
    //     tHeight = '56px'
    //   }
    //   return {
    //     marginTop: tHeight,
    //     height: `calc(100% - ${tHeight})`
    //   }
    // },
    // username: function () {
    //   if (this.staff) {
    //     return this.staff.portName
    //   } else {
    //     return null
    //   }
    // },
    // entityAbbr: function () {
    //   if (this.staff) {
    //     return this.staff.entityAbbr
    //   } else {
    //     return null
    //   }
    // },
    // ...mapState(workflowModule, {
    //   workItemCounts: state => state.allActiveWorkItemCounts
    // }),
    // ...mapState(staffModule, {
    //   // staffPhoto: state => state.photoInBase64,
    //   staff: state => state.info
    // })
    // ...mapGetters({
    //   taskTotalNumber: workflowModule + '/countPersonalTotalJobNumber'
    // })
  },
  watch: {
    // drawer: function (val) {
    //   if (val) {
    //     this.$store.dispatch(workflowModule + '/getAllActiveWorkItemCounts')
    //   }
    // }
  },
  mounted () {
    // this.onResize()
  },
  created () {
    if (this.$g2eOauth.isAuthenticated) {
      this.$g2eOauth.getTokenBody().then(data => {
        if (data.euid) {
          // this.$store.dispatch(workflowModule + '/getAllActiveWorkItemCounts')
          // // this.$store.dispatch(staffModule + '/getStaffPhoto')
          // g2eApi.getStaffPhoto(cb => {
          //   this.staffPhoto = 'data:image/jpeg;base64, ' + cb
          // })
          this.$store.dispatch(staffModule + '/getStaff')
        }
      },
      error => {
        console.log(error)
      })
    }
  },
  methods: {
    // onResize () {
    //   this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    // },
    changeLang: function () {
      let lang = storageUtil.getStorage('g2e-lang')
      if (!lang) {
        lang = 'zh-hant'
      }
      if (lang.indexOf('zh') >= 0) {
        storageUtil.setStorage('g2e-lang', 'pt')
        this.$i18n.locale = 'pt'
        this.$vuetify.lang.current = 'pt'
      } else {
        storageUtil.setStorage('g2e-lang', 'zh-hant')
        this.$i18n.locale = 'zh'
        this.$vuetify.lang.current = 'zhHant'
      }
    }
    // logout: function () {
    //   localStorage.removeItem(G2E_JWT_TOKEN)
    //   axios.defaults.headers.common['Authorization'] = ''
    //   location.href = LOGOUT_URL
    // }
  }
}
</script>
